import script from "./ExpancionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpancionPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ExpancionPanel.vue?vue&type=style&index=0&id=8dcce194&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dcce194"]])

export default __exports__